export default {
  ISSUE_GROUP: {
    CHROME_EXTENSION: 'chrome-extension',
    TAMPERMONKEY: 'dhdgffkkebhmkfjojejmpbldmpobfkfo',
  },
}
